import { MapPin, Phone } from "lucide-react";
import { SITE } from "@/lib/site-config";
import { SectionTitle } from "@/components/site/Features";

export default function MapSection() {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(
    SITE.mapQuery
  )}&output=embed`;

  return (
    <section
      id="location"
      data-testid="map-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto px-4 md:px-8">
        <SectionTitle
          eyebrow="Visit Us"
          title="Step into the campus."
          subtitle="We are easy to find — right beside Kunkai Devi Mandir, Vitawa, Thane."
        />

        <div className="mt-10 grid gap-6 lg:grid-cols-12">
          <div className="overflow-hidden rounded-md border border-slate-200 shadow-sm lg:col-span-8">
            <iframe
              data-testid="google-map-iframe"
              title="Gurukul Classes Location"
              src={mapSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-[320px] w-full border-0 md:h-[440px]"
              allowFullScreen
            />
          </div>

          <aside className="space-y-4 lg:col-span-4">
            <div className="rounded-md border border-slate-200 bg-slate-50 p-5 md:p-6">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-red-600 text-white">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <h4 className="font-display text-base font-bold text-slate-900">
                    Address
                  </h4>
                  <p className="mt-1 text-[14px] leading-relaxed text-slate-600">
                    {SITE.address}
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-md border border-slate-200 bg-slate-50 p-5 md:p-6">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-red-600 text-white">
                  <Phone className="h-5 w-5" />
                </span>
                <div>
                  <h4 className="font-display text-base font-bold text-slate-900">
                    Phone / WhatsApp
                  </h4>
                  <a
                    href={`tel:${SITE.phoneTel}`}
                    data-testid="contact-phone-link"
                    className="mt-1 block text-[15px] font-semibold text-red-600 hover:text-red-700"
                  >
                    {SITE.phoneDisplay}
                  </a>
                </div>
              </div>
            </div>

            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                SITE.mapQuery
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="open-in-maps-btn"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-red-700"
            >
              <MapPin className="h-4 w-4" />
              Open in Google Maps
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}
